export const JOIN_EXISTING_COMPANY_HELP_URL = 'https://help.routific.com/en/articles/27-how-to-join-an-existing-company';
export const PREDICTED_TRAFFIC_HELP_ARTICLE_URL = 'https://help.routific.com/en/articles/79-predicted-traffic';
export const PRICING_PLAN_DETAILS = 'https://www.routific.com/v3-pricing';
export const RT_TOS_URL = 'https://www.routific.com/tos';
export const RT_PRIVACY_URL = 'https://www.routific.com/privacy';
